import React from 'react'
import { Deal } from '@services/deals/types/deal';
import { Translate } from 'react-localize-redux';
import { useTheme } from 'styled-components';
import Typography from '../../../../../components/basics/typography';
import DineroFactory, { DineroObject } from 'dinero.js';
import DoughnutGraph from '../../../../analytics/doughnut-graph';
import { DealSummaryGrid, DealSummaryTitle } from '../components';

interface AdvanceDealsSummaryCtrlProps {
  className?: string;
  deals: Deal[];
}

const zeroAmount: DineroObject = {amount: 0, precision: 2, currency: 'USD'};

export const AdvanceDealsSummaryCtrl: React.FC<AdvanceDealsSummaryCtrlProps> = ({ className, deals }) => {
  const theme = useTheme();

  const advanced = deals.reduce((m, d) => m.add(d.advance!.advance), DineroFactory(zeroAmount))
  const avgTerm = deals.reduce((m, d) => m + (d.duration.term / (d.duration.frequency === 'months' ? 12 : 1)), 0) / (deals.length || 1);
  const recouped = deals.reduce((m, d) => m.add(d.recoupment || DineroFactory(zeroAmount)), DineroFactory(zeroAmount));

  const recoupmentPercent = recouped.toUnit() * 100 / advanced.toUnit();

  return (
    <DealSummaryGrid className={className }>
      <section>
        <DealSummaryTitle type="small" weight="700" color={theme.colors.tertiary} uppercase>
          <Translate id="LABEL.DEALS.SUMMARY.ADVANCE.TOTAL" />
        </DealSummaryTitle>
        <Typography customFont="semi-bold" type="section-title-preview">
          {advanced.toFormat()}
        </Typography>
      </section>
      <section>
        <DealSummaryTitle type="small" weight="700" color={theme.colors.tertiary} uppercase>
          <Translate id="LABEL.DEALS.SUMMARY.ADVANCE.TERMS" />
        </DealSummaryTitle>
        <Typography customFont="semi-bold" type="section-title-preview">
          {avgTerm} years
        </Typography>
      </section>
      <section>
        <DoughnutGraph
          data={[ {
            id: 'RECOUPMENT',
            label: 'Recoupment',
            value: recoupmentPercent || 65,
            color: '#0731E2',
          }, {
            id: 'BG',
            label: '',
            value: 100 - 65,
            color: 'rgba(140,142,149,0.1)',
          }]}
          customSize='50px'
          margin={1}
        />
      </section>
    </DealSummaryGrid>
  )
}